<template>
  <div class="lg:flex my-5">
    <div class="w-full flex flex-col items-start">
      <label class="block text-sm leading-5 font-medium text-gray-700">
        {{ label }}
      </label>
      <div
        ref="dropzone"
        class="mt-2 flex flex-col w-full justify-center px-6 pt-5 pb-6
        border-2 border-gray-300 border-dashed rounded-md relative"
      >
        <div v-if="!hasFile" class="text-center pointer-events-none">
          <svg
            class="mx-auto h-12 w-12 text-gray-400"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
          >
            <path
              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0
                01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4
                4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div class="text-sm text-gray-600">
            <transition name="fade-fast" mode="out-in">
              <p v-if="!dragOver" class="mt-1">
                <button class="font-medium text-green-500 hover:text-indigo-500 focus:outline-none
            focus:underline transition duration-150 ease-in-out">
                  Upload a file
                </button>
                or drag and drop
              </p>
              <p v-if="dragOver" class="mt-1">
                Drop your file to upload it!
              </p>
            </transition>
            <p class="mt-1 text-xs text-gray-500">
              PNG, JPG, PDF up to 10MB
            </p>
            <p
              v-if="error"
              class="mt-4 text-xs font-bold text-red-700"
            >
              {{ error }}
            </p>
          </div>
        </div>
        <div
          v-if="hasFile"
          class="p-2 flex-shrink-0 flex absolute top-0 right-0"
        >
          <button
            class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500
            transition ease-in-out duration-150"
            @click="removeFile"
          >
            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414
                10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0
                01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
        <span class="dz-hidden-input"></span>
      </div>
      <p class="block mt-3 text-sm text-gray-500">
        {{ hint }}
      </p>
    </div>
  </div>
</template>

<script>
import Dropzone from 'dropzone';

export default {
  name: 'FileInput',
  props: {
    value: {
      type: File,
      default: () => null,
    },
    label: {
      type: String,
      default: () => '',
    },
    hint: {
      type: String,
      default: () => '',
    },
    dropzoneConfig: {
      type: Object,
      default: () => ({
        url: `${process.env.VUE_APP_API_BASE_URL}/api/`,
        createImageThumbnails: false,
        acceptedFiles: '.jpg,.jpeg,.png,.pdf',
        maxFilesize: 10,
        hiddenInputContainer: '.dz-hidden-input',
        autoProcessQueue: false,
        uploadMultiple: false,
        maxFiles: 1,
        addRemoveLinks: false,
        dictFileTooBig: 'Maximum file size exceeded.',
        dictInvalidFileType: 'Invalid File Type.',
      }),
    },
  },
  data() {
    return {
      dropzone: null,
      dragOver: false,
      error: null,
    };
  },
  computed: {
    hasFile() {
      if (this.dropzone) {
        return this.dropzone.files.length > 0;
      }
      return false;
    },
  },
  methods: {
    removeFile() {
      this.dropzone.removeAllFiles();
    },
  },
  created() {
    Dropzone.autoDiscover = false;
  },
  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    this.dropzone = new Dropzone(this.$refs.dropzone, {
      ...this.dropzoneConfig,
      previewTemplate: `
        <div class="dz-details text-center ">
          <div class="dz-filename text-xs mb-3 text-gray-500"><span data-dz-name></span></div>
          <div class="dz-size text-xs text-gray-500" data-dz-size></div>
        </div>
      `,
      init() {
        this.on('addedfile', (file) => {
          vm.error = false;
          vm.$emit('input', file);
        });
        this.on('removedfile', (file) => {
          if (file.status !== 'error') {
            vm.error = false;
            vm.$emit('input', undefined);
          }
        });
        this.on('dragenter', () => {
          vm.dragOver = true;
        });
        ['dragend', 'dragleave', 'drop'].forEach((event) => {
          this.on(event, () => {
            vm.dragOver = false;
          });
        });
        this.on('error', (file, error) => {
          if (!file.accepted) {
            vm.error = error;
            this.removeFile(file);
          }
        });
      },
    });
  },
};
</script>
